import React, { useEffect, useRef, useState } from "react";
import "./SettlementReport.css";
import { useSelector } from "react-redux";
import { getTotalProviderSettlement } from "../../../config/LiveApi";
import { FcMoneyTransfer } from "react-icons/fc";
import Modal from "./ModalPaid";
import Pagination from "./Pagination";
import { FaCalendar } from "react-icons/fa";
import DownloadReportModal from "../downloadReport/Modal";
import DateFilter from "../../../components/common/DateFilter";

const SettlementTable = () => {
  const token = useSelector((store) => store.userReducer.token);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({ data: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState({ open: false, data: null });
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const allowedUsers = JSON.parse(
    import.meta.env.VITE_SETTLEMENT_PAY_USERS || "[]"
  );

  const userId = useSelector((store) => store.userReducer.userId);

  const isPayAmountAllowed =
    import.meta.env.VITE_APP_ENV === "local" &&
    allowedUsers.includes(userId);

  const getSettlementData = async (start = startDate, end = endDate) => {
    setLoading(true);
    try {
      const response = await getTotalProviderSettlement(
        token,
        currentPage,
        start,
        end
      );

      setTableData(response.data);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      getSettlementData();
    }
  }, [token, currentPage, startDate, endDate]);

  // ✅ SINGLE SOURCE OF TRUTH FOR DATE FILTER
  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    getSettlementData(start, end);
  };

  return (
    <>
      <div className="provider-settlement-report-container">
        <div className="provider-table-head">
          <div className="provider-settlement-report-title">
            Total Provider Settlement
          </div>
        </div>

        {/* ✅ REPLACED CALENDAR WITH COMMON COMPONENT */}
        <DateFilter onDateChange={handleDateChange} />

        <div className="provider-settlement-report-title">
          <button
            className="button-download-ps"
            onClick={() => setIsDownloadModalOpen(true)}
          >
            Download Report
          </button>
        </div>

        <table className="provider-settlement-report-table">
          <thead>
            <tr>
              <th>Provider Name</th>
              <th>Late Settlement</th>
              <th>On Time Settlement</th>
              <th>Total Settlement Amount</th>
              <th>Settlemnt Time Range</th>
              <th>Paid Amount</th>
              <th>Settled Date</th>
              {isPayAmountAllowed && <th>Pay Amount</th>}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8">Loading...</td>
              </tr>
            ) : tableData.data && tableData.data.length > 0 ? (
              tableData.data.map((reportData, i) => (
                <tr
                  key={i}
                  className={
                    reportData?.paidAmount <= 0 ? "highlight-row-red" : ""
                  }
                >
                  <td>{reportData?.providerName}</td>
                  <td>₹ {Number(reportData?.lateSettlement).toFixed(2)}</td>
                  <td>₹ {Number(reportData?.onTimeSettlement).toFixed(2)}</td>
                  <td>
                    ₹{" "}
                    {Number(
                      (reportData?.lateSettlement || 0) +
                        (reportData?.onTimeSettlement || 0)
                    ).toFixed(2)}
                  </td>
                  <td>{reportData?.settlementTimeRange}</td>
                  <td>₹ {reportData?.paidAmount}</td>

                  <td>
                    {new Date(reportData.settledDate).toLocaleString(
                      "en-GB"
                    )}
                  </td>

                  {isPayAmountAllowed && (
                    <td>
                      <FcMoneyTransfer
                        size={25}
                        onClick={() =>
                          setIsModalOpen({
                            open: true,
                            data: reportData,
                            paidAmount:
                              (reportData?.lateSettlement || 0) +
                              (reportData?.onTimeSettlement || 0),
                          })
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>

        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>

      {isModalOpen.open && (
        <Modal
          onClose={() => setIsModalOpen({ open: false, data: null })}
          reportData={isModalOpen.data}
          paidAmount={isModalOpen.paidAmount}
          refreshTableData={getSettlementData}
        />
      )}

      {isDownloadModalOpen && (
        <DownloadReportModal onClose={() => setIsDownloadModalOpen(false)} />
      )}
    </>
  );
};

export default SettlementTable;